<template>
  <div class="view">
    <div class="view__header">
      <h2>Dashboard</h2>
      <div class="view__header__controls">
        <button
          @click="openFetchrevOauthWindow()"
          class="btn btn-brand-primary fetchrev-connect-btn"
        >FetchRev Connect</button>
      </div>
    </div>
    <div class="view__content">
      <div class="card new-customers-card">
        <div class="card__header">
          <h3>New customer</h3>
        </div>
      </div>
      <div class="card daily-customers-card">
        <div class="card__header">
          <h3>Daily Customers</h3>
        </div>
      </div>
      <div class="card landing-page-card">
        <div class="card__header">
          <h3>Customize your Wifi Connector login lage</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';


export default {
  name: 'dashboard',

  methods: {
    ...mapActions(['setHostedLogoUrl']),
    openFetchrevOauthWindow() {
      const oauthURI = process.env.VUE_APP_LMA_OAUTH_REDIRECT_URI;
      const newWindow = window.open(
        oauthURI,
        'Connect to FetchRev',
        'height=500,width=450,left=200,scrollbars=no',
      );
      if (window.focus) {
        newWindow.focus();
      }
    },
  },
};
</script>

<style>
.new-customers-card {
  grid-column: 1 / 7;
  grid-row: auto;
}
.daily-customers-card {
  grid-column: 7 / end;
  grid-row: auto;
}

.landing-page-card {
  grid-column: 1 / end;
  grid-row: auto;
}
</style>
